import { createSlice } from "@reduxjs/toolkit";

export const DEFAULT_EXPENSE_DATE_BASIS = "voucher_order_date";

const initialState = {
  expenseDateBasis: DEFAULT_EXPENSE_DATE_BASIS,
};

export const AppConfigSlice = createSlice({
  name: "appConfig",
  initialState,
  reducers: {
    SET_EXPENSE_DATE_BASIS: (state, action) => {
      state.expenseDateBasis = action.payload || DEFAULT_EXPENSE_DATE_BASIS;
    },
  },
});

export const { SET_EXPENSE_DATE_BASIS } = AppConfigSlice.actions;
export default AppConfigSlice.reducer;
